"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _slide = _interopRequireDefault(require("./slide"));

var _sliderControls = _interopRequireDefault(require("./sliderControls"));

var _arrow = _interopRequireDefault(require("./arrow"));

require("./styles.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Slider = /*#__PURE__*/function (_Component) {
  _inherits(Slider, _Component);

  var _super = _createSuper(Slider);

  function Slider() {
    var _this;

    _classCallCheck(this, Slider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      currentIndex: 0,
      translateValue: 0,
      interval: null
    });

    _defineProperty(_assertThisInitialized(_this), "goToPreviousSlide", function () {
      var _this$state = _this.state,
          currentIndex = _this$state.currentIndex,
          translateValue = _this$state.translateValue;
      var slides = _this.props.slides;

      if (currentIndex === 0) {
        var lastIndex = slides.length - 1;

        _this.setTranslateValue(-lastIndex * _this.slideWidth());

        _this.setIndex(lastIndex);

        return;
      }

      _this.setTranslateValue(translateValue + _this.slideWidth());

      _this.setIndex(currentIndex - 1);
    });

    _defineProperty(_assertThisInitialized(_this), "goToNextSlide", function () {
      var _this$state2 = _this.state,
          currentIndex = _this$state2.currentIndex,
          translateValue = _this$state2.translateValue;
      var slides = _this.props.slides;

      if (currentIndex === slides.length - 1) {
        _this.setTranslateValue(0);

        return _this.setIndex(0);
      }

      _this.setTranslateValue(translateValue - _this.slideWidth());

      _this.setIndex(currentIndex + 1);

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "setIndex", function (currentIndex) {
      _this.setState({
        currentIndex: currentIndex
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setTranslateValue", function (translateValue) {
      _this.setState({
        translateValue: translateValue
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSlideClick", function (index) {
      var _this$state3 = _this.state,
          currentIndex = _this$state3.currentIndex,
          translateValue = _this$state3.translateValue;
      if (index === currentIndex) return;

      if (index > currentIndex) {
        _this.setTranslateValue(-index * _this.slideWidth());
      } else {
        _this.setTranslateValue(translateValue + (currentIndex - index) * _this.slideWidth());
      }

      _this.setIndex(index);
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      var autoplay = _this.props.autoplay;
      var prevInterval = _this.state.interval;

      if (autoplay && prevProps.autoplay !== autoplay) {
        var interval = window.setInterval(function () {
          _this.goToNextSlide();
        }, 3000);

        _this.setState({
          interval: interval
        });
      } else if (!autoplay && prevProps.autoplay !== autoplay) {
        var _interval = window.clearInterval(prevInterval);

        _this.setState({
          interval: _interval
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "slideWidth", function () {
      return document.querySelector(".slide").clientWidth;
    });

    return _this;
  }

  _createClass(Slider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          slides = _this$props.slides,
          hideControls = _this$props.hideControls;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "slider-cotainer"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "slider"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "slider-wrapper",
        style: {
          transform: "translateX(".concat(this.state.translateValue, "px)"),
          transition: "transform ease-out 0.45s"
        }
      }, slides.map(function (image, i) {
        return /*#__PURE__*/_react.default.createElement(_slide.default, {
          key: i,
          image: image
        });
      })), slides.length > 1 && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_arrow.default, {
        side: "prev",
        handleClick: this.goToPreviousSlide
      }), /*#__PURE__*/_react.default.createElement(_arrow.default, {
        side: "next",
        handleClick: this.goToNextSlide
      }))), !hideControls && /*#__PURE__*/_react.default.createElement(_sliderControls.default, {
        slides: slides,
        handleClick: this.handleSlideClick
      }));
    }
  }]);

  return Slider;
}(_react.Component);

_defineProperty(Slider, "defaultProps", {
  hideControls: false
});

Slider.propTypes = {
  slides: _propTypes.default.arrayOf(_propTypes.default.string),
  autoplay: _propTypes.default.bool,
  hideControls: _propTypes.default.bool
};
var _default = Slider;
exports.default = _default;